export default __webpack_public_path__ + "static/media/laptop-tech-specs.c7956437.png";